<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="消息中心" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="item in dataList" :key="item.SerialNumber">
          <router-link  :to="{path:'/MessageDetails?id=' + item.SerialNumber}" class="msg-list" >  <!-- to="/MessageDetails" -->
            <div class="hd">
              <h2 class="title">{{item.Title}}</h2>
              <p class="date">{{item.AddDateTime}}</p>
            </div>
            <div class="bd van-multi-ellipsis--l3">{{item.Content}}</div>
          </router-link>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <router-link to="/MessageDetails" class="msg-list" v-for="item in 5" :key="item.id">
        <div class="hd">
          <h2 class="title">清明节大优惠</h2>
          <p class="date">2016-1-3</p>
        </div>
        <div class="bd van-multi-ellipsis--l3">由崔迪谱曲、文雅填词，收录专辑中。该曲以自白式的歌词描写出姚贝娜对于过由崔迪谱曲、文雅填词，收录专辑中。该曲以自白式的歌词描写出姚贝娜对于过由崔迪谱曲、文雅填词，收录专辑中。该曲以自白式的歌词描写出姚贝娜对于过</div>
      </router-link>
    </div> -->
  </div>
</template>

<script>
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: false,
        finished: false,
        offset: 100,
        ischeck: false,
        options: null,
        dataList: []
	    };
	  },
	  components: {
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
    },
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      init() {
        var that = this;
        that.options = {
          type: "GetGenericArticleNewsList",
          pageIndex: 1
        };
        that.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1
        });
        this.loading = true;
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1
        });
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            var dataList = res.GenericArticleApiModelList;
            if (dataList.length <= 0) {
              that.finished = true;
            }

            if (dataList.length < 10){
              that.finished = true;
            }

            if (this.options.pageIndex > 1) {
              if (dataList.length > 0) {
                dataList.forEach(element => {
                  that.dataList.push(element);
                });
              }
            } 
            else {
              that.dataList = dataList;
            }
          },
          error => {}
        );
      }
    },
    created() {
      var that = this;
      that.init();
    }
	};
</script>

<style scoped>
.msg-list{
  background-color: #fff;
  padding: 15px;
  margin: 10px 0;
  overflow: hidden;
  display: block;
}
.msg-list>.hd{
  display: flex;
  align-items: center;
}
.msg-list>.hd>.title{
  font-size: 15px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.msg-list>.hd>.date{
  margin-left: 15px;
  font-size: 12px;
  color: #bbb;
}
.msg-list>.bd{
  margin-top: 6px;
  font-size: 14px;
  color: #555;
}
</style>
